import { useQuery } from 'react-query';

import { getHubDetailPageData } from 'api/traps/Hubs/getHubDetailPageData';

export const useGetHubDetailPage = (slug: string) => {
  const { data, refetch, isLoading, isRefetching } = useQuery('HubDetailPageData', () => getHubDetailPageData(slug), {
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading, isRefetching };
};

export default useGetHubDetailPage;
